import React, {useEffect, useMemo, useState} from 'react';
import ProductPrice, {ProductPricePropTypes} from "./ProductPrice";
import TitledName from "../TitledName/TitledName";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './styles/ProductPreview.scss';
import {TYPE_BUNDLE, TYPE_CPU, TYPE_FAN, TYPE_GPU, TYPE_MBO, TYPE_RAM} from "../../contants/common";
import {checkIsBundle} from '../../helpers';

export default function ProductPreview(props) {
  const {
    titleShort,
    imgSrc,
    type,
    isSelected,
    beforePrice,
    priceProps,
    onClickProduct,
    onClickInfo,
  } = props;

  const isBundle = useMemo(() => checkIsBundle(type), [type]);

  const selected = useMemo(() => isSelected, [isSelected]);

  const shouldShowInfoIcon = useMemo(() => {
    return (selected && !isBundle) || isBundle;
  }, [type, checkIsBundle, selected])

  return (
    <div onClick={onClickProduct} className={classNames('product-container', {
      "active": selected,
    })}>
      <div className="product-top">
        <div className="product-header">
          <span className={classNames("product-status", {
            selected
          })}>&nbsp;</span>
          {
            titleShort && <TitledName level={3} title={titleShort} className="product-title" />
          }
          {
            shouldShowInfoIcon && <span className="product-info"
                              onClick={e => {
                                e.stopPropagation();
                                onClickInfo();
                              }}>&nbsp;</span>
          }
        </div>
      </div>
      <div className="product-bottom">
        <div className={classNames(['product-img', type])}>
          <img src={imgSrc} alt={titleShort} />
        </div>
        {
          isBundle && <p className="product-price">
            {beforePrice && <span className="product-prefix">{beforePrice} </span>}
            <ProductPrice {...priceProps} />
          </p>
        }
      </div>
    </div>
  )
}

ProductPreview.propTypes = {
  titleShort: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    TYPE_BUNDLE,
    TYPE_GPU,
    TYPE_CPU,
    TYPE_MBO,
    TYPE_RAM,
    TYPE_FAN,
  ]).isRequired,
  onClickProduct: PropTypes.func.isRequired,
  onClickInfo: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  beforePrice: PropTypes.string,
  priceProps: ProductPricePropTypes,
}